import React, { useState, useEffect } from "react";
import ItemsCarousel from "react-items-carousel";
import TarjetaSlider from "../components/TarjetaSlider.js";
import { Button } from "antd";

export default (props) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;
  const [vehiculos, setVehiculos] = useState([]);

  const [firstAndLastGutter, setFirstAndLastGutter] = useState(false);
  const [cantTarjetas, setCantTarjetas] = useState(3);

  const size = useWindowSize();

  function useWindowSize() {
    const isClient = typeof window === "object";

    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
      };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
      if (!isClient) {
        return false;
      }

      function handleResize() {
        setWindowSize(getSize());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return windowSize;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (size.width < 450) {
      setCantTarjetas(1);
      setFirstAndLastGutter(false);
    } else {
      if (size.width < 700) {
        setCantTarjetas(2);
        setFirstAndLastGutter(true);
      } else {
        if (size.width < 800) {
          setCantTarjetas(2.7);
          setFirstAndLastGutter(true);
        } else {
          if (size.width < 1000) {
            setCantTarjetas(3.7);
            setFirstAndLastGutter(true);
          } else {
            setCantTarjetas(4.7);
            setFirstAndLastGutter(true);
          }
        }
      }
    }
  });

  useEffect(() => {
    var url = "https://store.lenken.com.ar/lenkenapi/autos/" + props.modelo;
    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((vehiculos) => {
        setVehiculos(vehiculos);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sliderModelo = () => {
    var links = vehiculos.map((vehiculo, i) => {
      return (
        <TarjetaSlider
          key={i}
          vehiculo={vehiculo}
          onSeleccionVehiculo={props.onSeleccionVehiculo}
          descuentos={props.descuentos}
        />
      );
    });
    return links;
  };

  const nombreModelorow = {
    background: "silver",
    height: "100px",
    fontFamily: "Audi Extended",
    fontSize: "70px",
    paddingLeft: "20px",
  };

  /*   const rutaImg =
    "https://store.lenken.com.ar/img/logos/" +
    props.modelo.toLowerCase() +
    ".png"; */

  const [bkgChevron, setBkgChevron] = useState("fondo-chevron-rojo");

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (bkgChevron === "fondo-chevron-rojo") {
        setBkgChevron("fondo-chevron-negro");
      } else {
        setBkgChevron("fondo-chevron-rojo");
      }
    }, 1000);
    return () => {
      window.clearTimeout(timer);
    };
  }, [bkgChevron]);

  return (
    <div>
      <div className="row valign-wrapper" style={nombreModelorow}>
        {props.modelo}
      </div>

      <div className="lateral" style={{ padding: `0 ${chevronWidth}px` }}>
        <ItemsCarousel
          infiniteLoop={false}
          activePosition={"center"}
          disableSwipe={false}
          alwaysShowChevrons={false}
          slidesToScroll={1}
          showSlither={false}
          firstAndLastGutter={firstAndLastGutter}
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={cantTarjetas}
          gutter={30}
          leftChevron={
            <Button
              className={bkgChevron + " btn btn-floating red chevronIzq "}
            >
              <i className="material-icons">chevron_left</i>
            </Button>
          }
          rightChevron={
            <Button
              className={bkgChevron + " btn btn-floating red chevronDer "}
            >
              <i className="material-icons">chevron_right</i>
            </Button>
          }
          outsideChevron={true}
          chevronWidth={chevronWidth}
        >
          {sliderModelo()}
        </ItemsCarousel>
      </div>
    </div>
  );
};
